import React from 'react'
import {Page, Splitter, SplitterContent, ActionSheet, ActionSheetButton} from 'react-onsenui'
import Loader from 'react-loader-spinner';
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom';
import {NaverMap, Marker, Polyline} from 'react-naver-maps';
import {Carousel} from 'react-responsive-carousel';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import ReactTimeAgo from 'react-time-ago';

import {showAlertMessage} from "../../modules/alert";
import {showToastMessage} from "../../modules/toast";
import SideMenu from "../app/sideMenu";
import {
    CHECK_ANONYMOUS,
    NAVER_THUMBNAIL_GETTER,
    SVG_MARKER_ICON,
    GET_HEIGHT_FOR_NAVER_MAP,
    DISTRICT_CODE,
    OPEN_EXTERNAL_LINK,
    GEO_LOCATION,
    SCHEDULE_SORT_KEY_TO_COLOR,
    DEFAULT_GPS_LOCATION,
    SCHEDULE_SORT_KEY_TO_NAME
} from "../../modules/variable/common_variable";
import UserInfoDialog from '../user/userInfoDialog';
import NoticeActionSheet from '../notice/noticeActionSheet';
import NearPlaceListActionSheet from '../schedule/module/nearPlaceListActionSheet';
import TargetScheduleActionSheetFunctions from '../schedule/module/targetScheduleActionSheetFunctions';
import TargetScheduleActionSheetDescription from "../schedule/module/targetScheduleActionSheetDescription";
import CommonComment from '../app/commonComment';
import WeatherCard from "./module/weatherCard";
import SimpleSearchNaverMap from "./module/SimpleSearchNaverMap";
import {removeUserInfo} from "../../modules/user";
import {useCurrentLocation} from "../../modules/native";
import {showTutorial} from "../../modules/tutorial";
import _ from "underscore";


class Home extends React.Component {
    constructor(props) {
        super(props);

        firebase.firestore().settings({timestampsInSnapshots: true});
        //firebase.functions().useFunctionsEmulator('http://localhost:5000');
        this.scheduleRef = firebase.firestore().collection('user_schedule');
        this.staffScheduleRef = firebase.firestore().collection('staff_schedule');
        this.noticeRef = firebase.firestore().collection('notice');
        this.placeRef = firebase.firestore().collection('place');

        let simpleSearchParameters = {code: 0, parentCode: 0, sort: null, order: 'recommend'};
        try {
            simpleSearchParameters = localStorage.getItem('savedSimpleSearchParameters') ? JSON.parse(localStorage.getItem('savedSimpleSearchParameters')) : {code: 0, parentCode: 0};
        } catch (e) {
            console.error(e);
        }
        simpleSearchParameters.sort = null;
        simpleSearchParameters.order = 'date';

        this.state = {
            openSideMenu: false,
            staffList: {isLoading: false, list: []},
            recommendList: {isLoading: false, list: []},
            myList: {isLoading: false, list: []},
            noticeList: {isLoading: true, list: []},
            targetScheduleActionSheet: {open: false, title: '', data: null, polyLine: [], mapCenter: {lat: 37.554690, lng: 126.970702}, targetToMapCenter: null, targetNaverPlaceActionSheet: null, tab: 'schedule'},
            noticeActionSheet: {open: false},
            nearPlaceListActionSheet: {open: false, placeId: '', placeName: ''},
            userInfoDialog: {open: false, uid: ''},
            showAppInstallSuggestionSection: {show: false, operationSystem: null},
            simpleSearchParameters: simpleSearchParameters,
            simpleSearchList: {isLoading: false, list: [], lastVisible: null, showMore: false, gpsLocation: null, bounds: null, currentSearchList: []},
            randomNearPlaceList: []
        };

        document.title = "피크니키: 나들이 어디로 갈까?"
    }

    naverMaps = window.naver.maps;

    /*trafficLayer = new window.naver.maps.TrafficLayer({
        interval: 2000
    });*/
    //streetLayer = new window.naver.maps.StreetLayer();
    //naverMapPanorama;

    componentDidMount(){
        /*this.setState({recommendList: {...this.state.recommendList, isLoading: false, list: TEMP_LIST}});
        this.setState({myList: {...this.state.myList, isLoading: false, list: TEMP_LIST.slice(0, 3)}});*/

        if(this.props.userInfo.isSignedIn){
            this.getHomeScreenScheduleList(this.props.userInfo);
        }

        setTimeout(() => {
            this.showAppInstallBanner();
        }, 3000);

        try {
            const savedGpsLocation = localStorage.getItem('savedGpsLocation');
            if(savedGpsLocation){
                const gpsLocation = JSON.parse(savedGpsLocation);
                if(gpsLocation.x && gpsLocation.y){
                    if(!gpsLocation.districtName){
                        this.getReverseGeoCoding(gpsLocation);
                    }else{
                        this.setState({simpleSearchList: {...this.state.simpleSearchList, gpsLocation: gpsLocation}});
                    }
                }
            }
        }catch (e) {
            console.error('GET GPS LOCATION ERROR');
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.userInfo.isSignedIn && nextProps.userInfo.isSignedIn){
            this.getHomeScreenScheduleList(nextProps.userInfo);
        }

        if(this.props.usedCurrentLocation === true && nextProps.usedCurrentLocation === false){
            this.setTargetToMapCenter(null, nextProps.currentLocation);
            this.getReverseGeoCoding(nextProps.currentLocation);
            this.props.useCurrentLocation();
        }
    }

    showAppInstallBanner = () => {
        let operationSystem = null;
        let showAppInstallSuggestion = false;
        try {
            if((!window.isRNWebView === true || !window.isRNWebView === 'true') && (!window.isETView === true || !window.isETView === 'true')){
                const hideAppInstallSuggestion = sessionStorage.getItem('hideAppInstallSuggestion');
                if(!hideAppInstallSuggestion || hideAppInstallSuggestion === 'false'){
                    const md = new window.MobileDetect(window.navigator.userAgent);
                    if(md.os() === 'iOS'){
                        operationSystem = 'iOS';
                        showAppInstallSuggestion = true;
                    }else if(md.os() === 'AndroidOS'){
                        operationSystem = 'AndroidOS';
                        showAppInstallSuggestion = true;
                    }else if(md.mobile() === null){
                        operationSystem = 'PC';
                        //showAppInstallSuggestion = true;
                    }
                    this.setState({showAppInstallSuggestionSection : {show: showAppInstallSuggestion, operationSystem: operationSystem}});
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    getHomeScreenScheduleList = (userInfo) => {
        //GET RANDOM NEAR PLACE LIST
        this.getNearPlaceList();

        this.setState({recommendList: {...this.state.recommendList, isLoading: true}, myList: {...this.state.myList, isLoading: true}, noticeList: {...this.state.noticeList, isLoading: true}});

        this.staffScheduleRef.orderBy("date", "desc").get().then((snapshot) => {
            let qd = [];
            snapshot.forEach((doc) => {
                let d = doc.data();
                d['DOC_ID'] = doc.id;
                qd.push(d);
            });
            this.setState({staffList: {...this.state.staffList, isLoading: false, list: qd}});

            const myQuery = this.scheduleRef.where("uid", "==", userInfo.uid).where("use", "==", true).orderBy("date", "desc").limit(3);
            myQuery.get().then((snapshot) => {
                let qd = [];
                snapshot.forEach((doc) => {
                    let d = doc.data();
                    d['DOC_ID'] = doc.id;
                    qd.push(d);
                });
                this.setState({myList: {...this.state.myList, isLoading: false, list: qd}});

                const recommendQuery = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy("recommend", "desc").limit(5);
                recommendQuery.get().then((snapshot) => {
                    let qd = [];
                    snapshot.forEach((doc) => {
                        if(doc.exists){
                            let d = doc.data();
                            //this.staffScheduleRef.doc(doc.id).set(d);
                            d['DOC_ID'] = doc.id;
                            qd.push(d);
                        }
                    });

                    this.setState({recommendList: {...this.state.recommendList, isLoading: false, list: qd}});

                    const noticeQuery = this.noticeRef.orderBy("date", "desc").limit(3);
                    noticeQuery.get().then((snapshot) => {
                        let qd = [];
                        snapshot.forEach((doc) => {
                            if(doc.exists){
                                let d = doc.data();
                                d['DOC_ID'] = doc.id;
                                qd.push(d);
                            }
                        });

                        this.setState({noticeList: {...this.state.noticeList, isLoading: false, list: qd}});
                    });
                });
            });
        });


        /*let queries = [];
        queries.push(this.scheduleRef.where("share", "==", true).orderBy("recommend", "desc").limit(5).get()); //recommend
        queries.push( this.scheduleRef.where("uid", "==", userInfo.uid).orderBy("date", "desc").limit(3).get()); //mine

        Promise.all(queries).then((snapshots) => {
            return snapshots.map(qs => qs.docs)
                .reduce((acc, docs) => [...acc, ...docs])
        }).then((matchingArticleRefs) => {
            console.log(matchingArticleRefs)
        })*/
    };

    showSideMenu = (show) => {
        this.setState({openSideMenu: show});
    };

    showTargetSchedule = (target) => {
        //this.trafficLayer.setMap(this.naverMapRef.map);

        //console.log(target);
        let naverMapPolyLineList = [];
        target.scheduleOrder.map((e) => {
            const so = target.schedule[e];
            naverMapPolyLineList.push(new this.naverMaps.LatLng(so.y, so.x));
        });
        const firstSchedule = target.schedule[target.scheduleOrder[0]];
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: true, title: target.title, data: target, polyLine: naverMapPolyLineList, mapCenter:{lat: firstSchedule.y, lng: firstSchedule.x}}});
    };

    showNaverPlaceInFunctions = (marker) => {
        //console.log(marker);
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetNaverPlaceActionSheet: {targetMarker: marker, open: true, isLoading: false, data: null}}});
    };

    setTargetToMapCenter = (event, target) => {
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }

        const mapCenter = {y: target.y, x: target.x, lat: target.y, lng: target.x};
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, mapCenter: mapCenter, targetToMapCenter: mapCenter}});
        setTimeout(() => {
            this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetToMapCenter: null}});
        }, 2000)
    };

    goToCreateSchedule = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        this.props.history.push("/createSchedule");
    };

    showUserInfoDialog = (event, uid) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({userInfoDialog: {...this.state.userInfoDialog, open: true, uid: uid}});
    };

    goToScheduleList = (type, parameter) => {
        if(type === 'MINE'){
            if(CHECK_ANONYMOUS(this.props, true)){return false}
        }

        this.props.history.push({
            pathname: '/listSchedule',
            state: {type: type, parameter: parameter}
        });
    };

    signInForAnonymousForCurrent = () => {
        firebase.auth().signOut().then(() => {
            this.props.removeUserInfo();
            this.props.history.push('/intro');
        }).catch(function(error) {
            console.error(error);
            this.props.showToastMessage('로그인 전환 과정에서 문제가 발생하였습니다.');
        });
    };

    requestCurrentLocation = () => {
        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_CURRENT_LOCATION'});
            window.postMessage(message, "*");
        }else{
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const gpsLocation = {y: position.coords.latitude, x: position.coords.longitude, lat: position.coords.latitude, lng: position.coords.longitude};
                    this.setTargetToMapCenter(null, gpsLocation);
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));
                    this.getReverseGeoCoding(gpsLocation);
                }, (error) => {
                    console.error(error);
                    this.props.showToastMessage('위치 정보를 확인하는 과정에서 오류가 발생하였습니다.');
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                this.props.showToastMessage('본 기기가 GPS를 지원하지 않습니다.');
            }
        }
    };

    /*showPanoramaNaverMapLayer = (event, target) => {
        console.log(target);
        console.log(this.naverMapRef);
        //this.streetLayer.setMap(this.naverMapRef.map);

        if(this.naverMapPanorama){
            this.naverMapPanorama.setPosition(new window.naver.maps.LatLng(target.y, target.x))
        }else{
            this.naverMapPanorama = new window.naver.maps.Panorama("naver-map-for-target", {
                position: new window.naver.maps.LatLng(target.y, target.x),
                pov: {
                    pan: -135,
                    tilt: 0,
                    fov: 200
                }
            });
        }
    };*/

    hideAppInstallSuggestion = () => {
        sessionStorage.setItem('hideAppInstallSuggestion', "true");
        this.setState({showAppInstallSuggestionSection: {...this.state.showAppInstallSuggestionSection, show: false}})
    };

    getSimpleSearchLocalSelector = () => {
        if(this.state.simpleSearchParameters.parentCode === 0){
            return (
                <select className="select-input select-input--material" value={0} onChange={(event) => this.changeSimpleSearchLocalParam(event, 'LOCAL')} style={{display: 'none'}}>
                    <option value={0}>전체</option>
                </select>
            )
        }

        const localDistrictCode = _.where(DISTRICT_CODE, {parentCode: this.state.simpleSearchParameters.parentCode});

        let localOptions = [];
        localOptions.push(<option key={['local','code',0].join('-')} value={0}>전체</option>);
        for(let i = 0; i < localDistrictCode.length; i ++){
            localOptions.push(<option key={['local','code',localDistrictCode[i].code].join('-')} value={localDistrictCode[i].code}>{localDistrictCode[i].name}</option>);
        }

        return (
            <select className="select-input select-input--material" value={this.state.simpleSearchParameters.code} onChange={(event) => this.changeSimpleSearchLocalParam(event, 'LOCAL')}>
                {localOptions}
            </select>
        )
    };

    changeSimpleSearchLocalParam = (event, type) => {
        const value = Number(event.target.value);

        let parameters = {};
        const sort = this.state.simpleSearchParameters.sort;
        const order = this.state.simpleSearchParameters.order;
        if(type === 'PARENT'){
            parameters = {code: 0, parentCode: value, sort: sort, order: order};
        }else if(type === 'LOCAL'){
            if(value !== 0){
                parameters = {code: value, parentCode: this.state.simpleSearchParameters.parentCode, sort: sort, order: order};
            }else{
                parameters = {code: 0, parentCode: this.state.simpleSearchParameters.parentCode, sort: sort, order: order};
            }
        }

        if(sort !== null){
            this.getSimpleSearchList(parameters, true);
        }
        this.setState({simpleSearchParameters: parameters});
        localStorage.setItem('savedSimpleSearchParameters', JSON.stringify(parameters));
    };

    changeSimpleSearchLOrder = (order) => {
        const simpleSearchParameters = this.state.simpleSearchParameters;
        let parameters = {code: simpleSearchParameters.code, parentCode: simpleSearchParameters.parentCode, sort: simpleSearchParameters.sort, order: order};
        if(simpleSearchParameters.sort !== null){
            this.getSimpleSearchList(parameters, true);
        }
        this.setState({simpleSearchParameters: parameters});
    };

    selectSimpleSearchSort = (sort) => {
        let parameters = this.state.simpleSearchParameters;
        parameters.sort = sort;
        this.getSimpleSearchList(parameters, true);
        this.setState({simpleSearchParameters: parameters});
    };

    getSimpleSearchList = (parameters, first) => {
        if(first){
            this.setState({simpleSearchList: {...this.state.simpleSearchList, isLoading: true, lastVisible: null, list: []}});
        }else{
            this.setState({simpleSearchList: {...this.state.simpleSearchList, isLoading: true}});
        }

        let query = this.scheduleRef.where("use", "==", true).where("share", "==", true);
        if(parameters.parentCode !== 0){
            if(parameters.code === 0){
                query = query.where("representative.parent.parentCode", "==", parameters.parentCode);
            }else{
                query = query.where("representative.district.code", "==", parameters.code);
            }
        }

        if(parameters.sort !== 'all'){
            query = query.where("sort." + parameters.sort, "==", true);
        }

        if(parameters.order === 'recommend'){
            query = query.orderBy("recommend", "desc");
        }else{
            query = query.orderBy("date", "desc");
        }

        if(!first){
            query = query.startAfter(this.state.simpleSearchList.lastVisible);
        }

        let bounds = {minX: 0, minY: 0, maxX: 0, maxY: 0};
        query = query.limit(20);
        query.get().then((snapshot) => {
            const lastVisible = snapshot.docs[snapshot.docs.length-1];
            let qd = [];
            snapshot.forEach((doc) => {
                if(doc.exists){
                    let d = doc.data();
                    d['DOC_ID'] = doc.id;
                    qd.push(d);

                    if(bounds.minX === 0 || bounds.minX > d.schedule[d.scheduleOrder[0]].x){
                        bounds.minX = parseFloat(d.schedule[d.scheduleOrder[0]].x);
                    }
                    if(bounds.minY === 0 || bounds.minY > d.schedule[d.scheduleOrder[0]].y){
                        bounds.minY = parseFloat(d.schedule[d.scheduleOrder[0]].y);
                    }
                    if(bounds.maxX === 0 || bounds.maxX < d.schedule[d.scheduleOrder[0]].x){
                        bounds.maxX = parseFloat(d.schedule[d.scheduleOrder[0]].x);
                    }
                    if(bounds.maxY === 0 || bounds.maxY < d.schedule[d.scheduleOrder[0]].y){
                        bounds.maxY = parseFloat(d.schedule[d.scheduleOrder[0]].y);
                    }
                }
            });
            let showMore = true;
            if(qd.length < 20){
                showMore = false;
            }

            this.setState({
                simpleSearchList: {
                    ...this.state.simpleSearchList,
                    bounds: bounds,
                    currentSearchList: qd
                }
            });

            if(first){
                this.setState({simpleSearchList: {...this.state.simpleSearchList, isLoading: false, lastVisible: lastVisible, list: qd, showMore: showMore}});
            }else{
                this.setState({simpleSearchList: {...this.state.simpleSearchList, isLoading: false, lastVisible: lastVisible, list: this.state.simpleSearchList.list.concat(qd), showMore: showMore}});
            }
        });
    };

    getDistanceInSimpleList = (gl, d) => {
        let distanceFrom = '0km';
        try {
            let rd = GEO_LOCATION.getDistance({latitude: gl.y, longitude: gl.x},{latitude: parseFloat(d.schedule[d.scheduleOrder[0]].y), longitude: parseFloat(d.schedule[d.scheduleOrder[0]].x)});
            if(rd < 1){
                distanceFrom = parseInt(rd * 1000) + 'm';
            }else{
                distanceFrom = parseInt(rd) + 'km'
            }
        } catch (e) {
            distanceFrom = null;
            console.error(e);
        }
        return distanceFrom;
    };

    getReverseGeoCoding = (gpsLocation) => {
        const getReverseGeoCoding = firebase.functions().httpsCallable('getReverseGeoCoding');
        getReverseGeoCoding({x: gpsLocation.x, y: gpsLocation.y}).then((result) => {
            if(result.data.result === 'success'){
                const data = JSON.parse(result.data.data);
                try {
                    if(data.status.name === 'ok'){
                        let districtName = "";
                        for(let i = 1; i < 5; i ++){
                            if(data.results[0].region["area" + i] && data.results[0].region["area" + i].name && data.results[0].region["area" + i].name !== ""){
                                districtName += data.results[0].region["area" + i].alias? data.results[0].region["area" + i].alias + " " : data.results[0].region["area" + i].name + " ";
                            }
                        }
                        if(districtName !== ""){
                            gpsLocation.districtName = districtName;
                            this.setState({simpleSearchList: {...this.state.simpleSearchList, gpsLocation: gpsLocation}});
                            localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        });
    };

    getNearPlaceList = () => {
        let nearPlaceList = sessionStorage.getItem('nearPlaceList');
        if(nearPlaceList){
            nearPlaceList = JSON.parse(nearPlaceList);
            this.renderNearPlaceList(nearPlaceList);
        }else{
            const savedGpsLocation  = localStorage.getItem('savedGpsLocation');
            let gpsLocation;
            let boundaryRange;
            if(savedGpsLocation){
                try {
                    gpsLocation = JSON.parse(savedGpsLocation);
                    if(!gpsLocation.x || !gpsLocation.y){
                        gpsLocation = null;
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            let placeQuery = this.placeRef;
            if(gpsLocation){
                boundaryRange = GEO_LOCATION.buildLocationRange(gpsLocation.y, gpsLocation.x, 30);
                placeQuery = placeQuery.where("y", ">", boundaryRange.minLat);
                placeQuery = placeQuery.where("y", "<", boundaryRange.maxLat);
            }
            placeQuery = placeQuery.limit(100);

            placeQuery.get().then((snapshot) => {
                let qd = [];
                snapshot.forEach((doc) => {
                    if(doc.exists){
                        let d = doc.data();
                        d['DOC_ID'] = doc.id;
                        qd.push(d);
                    }
                });

                nearPlaceList = [];
                for(let i = 0; i < qd.length; i ++){
                    if(gpsLocation){
                        if(qd[i].x > boundaryRange.minLon && qd[i].x < boundaryRange.maxLon && qd[i].imageSrc !== ''){
                            nearPlaceList.push(qd[i]);
                        }
                    }else{
                        if(qd[i].imageSrc !== ''){
                            nearPlaceList.push(qd[i]);
                        }
                    }
                }
                if(nearPlaceList.length !== 0){
                    this.renderNearPlaceList(nearPlaceList);
                    sessionStorage.setItem('nearPlaceList', JSON.stringify(nearPlaceList));
                }
            });
        }
    };

    renderNearPlaceList = (nearPlaceList) => {
        let randomNearPlaceList = [];
        let t = Array.from({length: nearPlaceList.length}, () => Math.floor(Math.random() * nearPlaceList.length));
        t = _.uniq(t);
        for(let i = 0; i < Math.min(nearPlaceList.length, 16); i ++){
            randomNearPlaceList.push(nearPlaceList[t[i]]);
        }

        this.setState({randomNearPlaceList: randomNearPlaceList});
    };

    render() {
        const TSAS = this.state.targetScheduleActionSheet;
        const SL = this.state.staffList.list;
        const RL = this.state.recommendList.list;
        const ML = this.state.myList.list;
        const NL = this.state.noticeList.list;

        return (
            <Splitter>
                <SideMenu openSideMenu={this.state.openSideMenu} showSideMenu={this.showSideMenu}/>
                <SplitterContent>
                    <Page>
                        <div className="toolbar toolbar--transparent">
                            <div className="toolbar__left">
                                {
                                    this.props.userInfo.isAnonymous ?
                                        <span className="toolbar-button" style={{fontSize: '14px'}} onClick={this.signInForAnonymousForCurrent}>
                                            <i className="fa fa-sign-in" style={{fontSize: '18px', marginRight: '5px'}}/>
                                            로그인
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="toolbar__center">
                                <img src={'/assets/image/intro/logo_only_192.png'} style={{width: '24px', height: '24px'}}/> PICNIC<strong style={{color: '#f2a22c'}}>I</strong>
                            </div>
                            <div className="toolbar__right">
                                <span className="toolbar-button" onClick={() => this.props.showTutorial('ENTIRE_OVERVIEW')}>
                                    <i className="fa fa-question-circle-o" style={{fontSize: '18px', lineHeight: '18px',verticalAlign: 'top', marginTop: '13px'}}/>
                                </span>
                                <span className="toolbar-button TUTO_SIDE_BUTTON" onClick={() => this.showSideMenu(true)}>
                                    <i className="ion-navicon" style={{fontSize: '28px'}}/>
                                </span>
                            </div>
                        </div>

                        {
                            this.state.showAppInstallSuggestionSection.show ?
                                <div className="home-app-install-suggestion-wrapper">
                                    <ul className="list--material list">
                                        {
                                            this.state.showAppInstallSuggestionSection.operationSystem === 'iOS' ?
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__left list-item--material__left">
                                                        <i className="fa fa-apple"/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center" onClick={() => OPEN_EXTERNAL_LINK('https://itunes.apple.com/kr/app//id1453041236?mt=8')}>
                                                        <div className="list-item__title">
                                                            <p>아이폰 앱으로 피크니키를 만나보세요.</p>
                                                        </div>
                                                        <div className="list-item__subtitle">
                                                        </div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right" onClick={this.hideAppInstallSuggestion}>
                                                        <i className="fa fa-close"/>
                                                    </div>
                                                </li>
                                                :
                                                this.state.showAppInstallSuggestionSection.operationSystem === 'AndroidOS' ?
                                                    <li className="list-item list-item--material">
                                                        <div className="list-item__left list-item--material__left">
                                                            <i className="fa fa-android"/>
                                                        </div>
                                                        <div className="list-item__center list-item--material__center" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.hopse.picnici")}>
                                                            <div className="list-item__title">
                                                                <p>안드로이드 앱으로 피크니키를 만나보세요.</p>
                                                            </div>
                                                            <div className="list-item__subtitle">
                                                            </div>
                                                        </div>
                                                        <div className="list-item__right list-item--material__right" onClick={this.hideAppInstallSuggestion}>
                                                            <i className="fa fa-close"/>
                                                        </div>
                                                    </li>
                                                    :
                                                    this.state.showAppInstallSuggestionSection.operationSystem === 'PC' ?
                                                        <li className="list-item list-item--material">
                                                            <div className="list-item__left list-item--material__left">
                                                                <i className="fa fa-laptop"/>
                                                            </div>
                                                            <div className="list-item__center list-item--material__center" onClick={() => window.open("https://firebasestorage.googleapis.com/v0/b/picnici.appspot.com/o/PICNICI_Setup_1.0.0.exe?alt=media&token=f717c972-697d-406a-8dba-dbe638cbeb6d")}>
                                                                <div className="list-item__title">
                                                                    <p>PC 앱으로 피크니키를 만나보세요.</p>
                                                                </div>
                                                                <div className="list-item__subtitle">
                                                                </div>
                                                            </div>
                                                            <div className="list-item__right list-item--material__right" onClick={this.hideAppInstallSuggestion}>
                                                                <i className="fa fa-close"/>
                                                            </div>
                                                        </li>
                                                        :
                                                        null
                                        }
                                    </ul>
                                </div>
                                :
                                null
                        }

                        <div>
                            <ul className="list--material list">
                                <li className="list-header list-header--material">스태프 일정</li>
                                {
                                    !this.state.staffList.isLoading && RL.length !== 0 ?
                                        <li>
                                            <Carousel autoPlay={true} showStatus={false} showThumbs={false} interval={5000} centerMode={window.screenSizeProperty === 'md'} centerSlidePercentage={(300 / 174 * 300) / window.innerWidth * 100}>
                                                {
                                                    SL.map((e, i) => {
                                                        const s = e.schedule[e.scheduleOrder[0]];

                                                        if (s.imageSrc) {
                                                            return (
                                                                <div key={['carousel', i].join('_')} onClick={() => this.showTargetSchedule(e)}>
                                                                    <img src={['https://search.pstatic.net/common/?autoRotate=true&quality=95&src=', s.imageSrc, '&type=f300_174'].join('')} alt={s.name} style={window.screenSizeProperty === 'md' ? {maxHeight: '300px'} : {height: '225px'}}/>
                                                                    <p className="legend">{e.title}</p>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                            </Carousel>
                                        </li>
                                        :
                                        <li className="list-item list-item--material">
                                            <div className="list-item__title list-item--material__title text-center">
                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40}/>
                                            </div>
                                        </li>
                                }
                            </ul>
                        </div>

                        <div className="TUTO_HOME_SIMPLE_SEARCH">
                            <ul className="list--material list home-card-list schedule-simple-search-wrapper">
                                <li className="list-header list-header--material" style={{padding : "8px 16px 0 16px"}}>
                                    일정 간편 검색
                                    <button className="button--quiet" onClick={this.requestCurrentLocation}>
                                        <i className="ion ion-android-locate"/>
                                    </button>
                                    {
                                        this.state.simpleSearchList.gpsLocation && this.state.simpleSearchList.gpsLocation.districtName ?
                                            <small>{'거리 기준: ' + this.state.simpleSearchList.gpsLocation.districtName}</small>
                                            :
                                            null
                                    }
                                </li>
                                <li className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center schedule-simple-search-local-wrapper">
                                        <span>지역: </span>
                                        <select className="select-input select-input--material" value={this.state.simpleSearchParameters.parentCode} onChange={(event) => this.changeSimpleSearchLocalParam(event, 'PARENT')}>
                                            <option value={0}>전체</option><option value={11}>서울</option><option value={41}>경기</option><option value={26}>부산</option><option value={27}>대구</option><option value={28}>인천</option><option value={29}>광주</option>
                                            <option value={30}>대전</option><option value={31}>울산</option><option value={36}>세종</option><option value={42}>강원</option><option value={43}>충북</option>
                                            <option value={44}>충남</option><option value={45}>전북</option><option value={46}>전남</option><option value={47}>경북</option><option value={48}>경남</option>
                                            <option value={50}>제주</option>
                                        </select>
                                        {this.getSimpleSearchLocalSelector()}
                                        
                                        <div className="list-item__right list-item--material__right schedule-simple-search-sort-wrapper">
                                            <label className="radio-button radio-button--material">
                                                <input type="radio" className="radio-button__input radio-button--material__input" name="schedule-simple-search-order" checked={this.state.simpleSearchParameters.order === 'date'} onChange={() => this.changeSimpleSearchLOrder('date')}/>
                                                <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                날짜
                                            </label>
                                            <label className="radio-button radio-button--material">
                                                <input type="radio" className="radio-button__input radio-button--material__input" name="schedule-simple-search-order" checked={this.state.simpleSearchParameters.order === 'recommend'} onChange={() => this.changeSimpleSearchLOrder('recommend')}/>
                                                    <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                    추천
                                            </label>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center schedule-simple-search-category-title-wrapper">
                                        <span>카테고리: </span>
                                        <button className="button button--material--flat" onClick={() => this.selectSimpleSearchSort('all')}>전체</button>
                                    </div>
                                </li>
                                <li className="list-item list-item--material" style={{marginBottom: '4px'}}>
                                    <div className="list-item__center list-item--material__center">
                                        <div className="tabbar tabbar--material">
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'date'} onChange={() => this.selectSimpleSearchSort('date')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['date']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-heart"/>
                                                    <div className="tabbar__label tabbar--material__label">만남</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'picnic'} onChange={() => this.selectSimpleSearchSort('picnic')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['picnic']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-child"/>
                                                    <div className="tabbar__label tabbar--material__label">소풍</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'sightseeing'} onChange={() => this.selectSimpleSearchSort('sightseeing')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['sightseeing']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-eye"/>
                                                    <div className="tabbar__label tabbar--material__label">관광</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'shopping'} onChange={() => this.selectSimpleSearchSort('shopping')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['shopping']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-shopping-bag"/>
                                                    <div className="tabbar__label tabbar--material__label">쇼핑</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'eating'} onChange={() => this.selectSimpleSearchSort('eating')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['eating']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-cookie-bite"/>
                                                    <div className="tabbar__label tabbar--material__label">먹자</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'history'} onChange={() => this.selectSimpleSearchSort('history')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['history']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-history"/>
                                                    <div className="tabbar__label tabbar--material__label">역사</div>
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center">
                                        <div className="tabbar tabbar--material">
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'study'} onChange={() => this.selectSimpleSearchSort('study')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['study']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-user-graduate"/>
                                                    <div className="tabbar__label tabbar--material__label">학습</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'healing'} onChange={() => this.selectSimpleSearchSort('healing')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['healing']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-tree"/>
                                                    <div className="tabbar__label tabbar--material__label">힐링</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'activity'} onChange={() => this.selectSimpleSearchSort('activity')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['activity']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-walking"/>
                                                    <div className="tabbar__label tabbar--material__label">활동</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'sport'} onChange={() => this.selectSimpleSearchSort('sport')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['sport']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-swimmer"/>
                                                    <div className="tabbar__label tabbar--material__label">운동</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'outside'} onChange={() => this.selectSimpleSearchSort('outside')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['outside']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-door-open"/>
                                                    <div className="tabbar__label tabbar--material__label">실외</div>
                                                </button>
                                            </label>
                                            <label className="tabbar__item tabbar--material__item">
                                                <input type="radio" name="schedule-sort" checked={this.state.simpleSearchParameters.sort === 'inside'} onChange={() => this.selectSimpleSearchSort('inside')}/>
                                                <button className="tabbar__button tabbar--material__button" style={{color: SCHEDULE_SORT_KEY_TO_COLOR['inside']}}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-door-closed"/>
                                                    <div className="tabbar__label tabbar--material__label">실내</div>
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <ul className="list--material list home-card-list" style={this.state.simpleSearchParameters.sort !== null ? {margin: 0} : {display: 'none'}}>
                                {
                                    this.state.simpleSearchParameters.sort !== null ?
                                        this.state.simpleSearchList.list.map((e, i) => {
                                            return (
                                                <li key={['recommend', 'list', i].join('_')} className="list-item list-item--material" onClick={() => this.showTargetSchedule(e)}>
                                                    <div className="list-item__left list-item--material__left">
                                                        <img className="list-item__thumbnail"
                                                             src={NAVER_THUMBNAIL_GETTER(e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]])}
                                                             onError={(event) => {
                                                                 event.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                             }} alt={e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]].name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title">{e.title}</div>
                                                        <div className="list-item__subtitle">
                                                            <span onClick={(event) => this.showUserInfoDialog(event, e.uid)}>
                                                                {e.nickname}
                                                            </span>
                                                            {
                                                                this.state.simpleSearchParameters.order === 'recommend' ?
                                                                    <small><i className="fa fa-thumbs-up"/> {e.recommend}</small>
                                                                    :
                                                                    <small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small>
                                                            }
                                                            {
                                                                e.sort ?
                                                                    <small style={{marginLeft: '4px'}}>
                                                                        {
                                                                            e.sort ?
                                                                                Object.keys(e.sort).map((k, j) => {
                                                                                    if(e.sort[k] === true){
                                                                                        return (
                                                                                            <span key={['near', 'schedule', 'sort', i, j].join('_')} className="notification notification--material notification-sort">{SCHEDULE_SORT_KEY_TO_NAME[k]}</span>
                                                                                        )
                                                                                    }
                                                                                })
                                                                                :
                                                                                null
                                                                        }
                                                                    </small>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right">
                                                        {
                                                            this.state.simpleSearchList.gpsLocation ?
                                                                <span className="notification notification--material notification-distance">{this.getDistanceInSimpleList(this.state.simpleSearchList.gpsLocation, e)}</span>
                                                                :
                                                                <span className="notification notification--material" onClick={() => this.goToScheduleList('SHARE', {code: e.representative.district.code})}>{e.representative.district.name.substring(0,3)}</span>
                                                        }
                                                    </div>
                                                </li>
                                            )
                                        })
                                        :
                                        null
                                }

                                {
                                    this.state.simpleSearchParameters.sort !== null ?
                                        this.state.simpleSearchList.isLoading ?
                                            <li className="list-item list-item--material">
                                                <div className="list-item__title list-item--material__title text-center">
                                                    <Loader type="ThreeDots" color="#00BFFF" height={40} width={40}/>
                                                </div>
                                            </li>
                                            :
                                            null
                                        :
                                        null
                                }

                                {
                                    this.state.simpleSearchParameters.sort !== null ?
                                        this.state.simpleSearchList.list.length === 0 && !this.state.simpleSearchList.isLoading ?
                                            <li className="list-item list-item--material">
                                                <div className="list-item__center list-item--material__center" style={{ minHeight: 'auto', marginBottom: '8px'}}>
                                                    <div className="list-item__title text-center">검색된 일정이 없습니다.</div>
                                                </div>
                                            </li>
                                            :
                                            null
                                        :
                                        null
                                }

                                {
                                    this.state.simpleSearchParameters.sort !== null ?
                                        this.state.simpleSearchList.showMore && !this.state.simpleSearchList.isLoading ?
                                            <li className="list-item list--inset__item list-item--chevron list-item--chevron-down list-schedule-list" onClick={() => this.getSimpleSearchList(this.state.simpleSearchParameters, false)}>
                                                <div className="list-item__center">더보기</div>
                                            </li>
                                            :
                                            null
                                        :
                                        null
                                }
                            </ul>

                            <div className="card card--material schedule-simple-search-map-wrapper">
                                <SimpleSearchNaverMap simpleSearchList={this.state.simpleSearchList} showTargetSchedule={this.showTargetSchedule}/>
                            </div>
                        </div>

                        <ul className="list--material list home-card-list ">
                            <li className="list-header list-header--material">추천 장소
                                <button className="button button--material--flat home-create-button" onClick={this.getNearPlaceList}><i className="fa fa-refresh"/></button>
                            </li>
                            {
                                this.state.randomNearPlaceList.length !== 0 ?
                                    <li>
                                        <Carousel autoPlay={true} showStatus={false} showThumbs={false} interval={5000} showIndicators={false} swipeable={false} centerMode={true} centerSlidePercentage={window.screenSizeProperty === 'md' ? parseFloat((300 / 174 * 300) / window.innerWidth * 100 / 2) : parseFloat(123 / window.innerWidth * 100)}>
                                            {
                                                this.state.randomNearPlaceList.map((e, i) => {
                                                    if (e.imageSrc) {
                                                        return (
                                                            <div key={['carousel', 'place', i].join('_')} onClick={() => this.setState({'nearPlaceListActionSheet': {...this.state.nearPlaceListActionSheet, open: true, placeId: e.id, placeName: e.name}})}>
                                                                <img src={['https://search.pstatic.net/common/?autoRotate=true&quality=95&src=', e.imageSrc, window.screenSizeProperty === 'md' ? '&type=f300_174' : '&type=f82_82'].join('')} alt={e.name} style={window.screenSizeProperty === 'md' ? {maxHeight: '150px'} : {height: '120px'}}/>
                                                                <div className="legend text-left home-recommend-place-list">
                                                                    <p className="home-recommend-place-list-name">
                                                                        {e.name}
                                                                        &nbsp;
                                                                        {
                                                                            window.screenSizeProperty === 'md' ?
                                                                                <small>{e.category}</small>
                                                                                :
                                                                                null
                                                                        }
                                                                    </p>
                                                                    {
                                                                        window.screenSizeProperty === 'md' ?
                                                                            <p className="home-recommend-place-list-desc">{e.desc}</p>
                                                                            :
                                                                            <small>{e.category}</small>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </Carousel>
                                    </li>
                                    :
                                    <li className="list-item list-item--material">
                                        <div className="list-item__title list-item--material__title text-center">
                                            <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                        </div>
                                    </li>
                            }
                        </ul>

                        <div>
                            <ul className="list--material list home-card-list TUTO_HOME_USER_LIST">
                                <li className="list-header list-header--material">유저 일정</li>
                                {
                                    !this.state.recommendList.isLoading ?
                                        RL.map((e, i) => {
                                            return (
                                                <li key={['recommend', 'list', i].join('_')} className="list-item list-item--material" onClick={() => this.showTargetSchedule(e)}>
                                                    <div className="list-item__left list-item--material__left">
                                                        <img className="list-item__thumbnail"
                                                             src={NAVER_THUMBNAIL_GETTER(e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]])}
                                                             onError={(e) => {
                                                                 e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                             }} alt={e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]].name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title">{e.title}</div>
                                                        <div className="list-item__subtitle">
                                                            <span onClick={(event) => this.showUserInfoDialog(event, e.uid)}>
                                                                {e.nickname}
                                                            </span>
                                                            <small><i className="fa fa-thumbs-up"/> {e.recommend}</small>
                                                            {
                                                                e.sort ?
                                                                    <small style={{marginLeft: '4px'}}>
                                                                        {
                                                                            e.sort ?
                                                                                Object.keys(e.sort).map((k, j) => {
                                                                                    if(e.sort[k] === true){
                                                                                        return (
                                                                                            <span key={['near', 'schedule', 'sort', i, j].join('_')} className="notification notification--material notification-sort">{SCHEDULE_SORT_KEY_TO_NAME[k]}</span>
                                                                                        )
                                                                                    }
                                                                                })
                                                                                :
                                                                                null
                                                                        }
                                                                    </small>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right">
                                                        <span className="notification notification--material" onClick={() => this.goToScheduleList('SHARE', {code: e.representative.district.code})}>{e.representative.district.name.substring(0,3)}</span>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        :
                                        <li className="list-item list-item--material">
                                            <div className="list-item__title list-item--material__title text-center">
                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                            </div>
                                        </li>
                                }
                                <li className="list-item list--inset__item list-item--chevron home-card-list-show-more" onClick={() => this.goToScheduleList('SHARE', null)}>
                                    <div className="list-item__center">더보기</div>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <ul className="list--material list home-card-list TUTO_HOME_MY_LIST">
                                <li className="list-header list-header--material">내 일정
                                    <button className="button button--material--flat home-create-button" onClick={this.goToCreateSchedule}>일정 만들기</button>
                                </li>

                                {
                                    !this.state.myList.isLoading && ML.length === 0 ?
                                        <li className="list-item list-item--material">
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title">작성한 일정이 없습니다.</div>
                                            </div>
                                        </li>
                                        :
                                        null
                                }

                                {
                                    !this.state.myList.isLoading ?
                                        ML.map((e, i) => {
                                            return (
                                                <li key={['recommend', 'list', i].join('_')} className="list-item list-item--material" onClick={() => this.showTargetSchedule(e)}>
                                                    <div className="list-item__left list-item--material__left">
                                                        <img className="list-item__thumbnail"
                                                             src={NAVER_THUMBNAIL_GETTER(e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]])}
                                                             onError={(e) => {
                                                                 e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                             }} alt={e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]].name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title">{e.title}</div>
                                                        <div className="list-item__subtitle"><small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small></div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right">
                                                        <span className="notification notification--material" onClick={() => this.goToScheduleList('SHARE', {code: e.representative.district.code})}>{e.representative.district.name.substring(0,3)}</span>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        :
                                        <li className="list-item list-item--material">
                                            <div className="list-item__title list-item--material__title text-center">
                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                            </div>
                                        </li>
                                }
                                <li className="list-item list--inset__item list-item--chevron home-card-list-show-more" onClick={() => this.goToScheduleList('MINE', null)}>
                                    <div className="list-item__center">더보기</div>
                                </li>
                            </ul>
                        </div>

                        <WeatherCard/>

                        <div>
                            <ul className="list--material list home-card-list">
                                <li className="list-header list-header--material">공지 사항</li>
                                {
                                    !this.state.noticeList.isLoading ?
                                        NL.map((e, i) => {
                                            return (
                                                <li key={['notice', 'list', i].join('_')} className="list-item list-item--material" onClick={() => this.props.showAlertMessage(e.detail, e.title)}>
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title" style={{fontSize: '12px'}}>{e.title}</div>
                                                        <div className="list-item__subtitle"/>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right">
                                                        <small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        :
                                        <li className="list-item list-item--material">
                                            <div className="list-item__title list-item--material__title text-center">
                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                            </div>
                                        </li>
                                }
                                <li className="list-item list--inset__item list-item--chevron list-item--chevron-down home-card-list-show-more" onClick={() => this.setState({noticeActionSheet: {...this.state.noticeActionSheet, open: true}})}>
                                    <div className="list-item__center">더보기</div>
                                </li>
                            </ul>
                        </div>


                        <div>
                            <ul className="list--material list home-card-list" style={{maxHeight: '378px',overflowY: 'auto'}}>
                                <li className="list-header list-header--material">자유 게시판</li>
                                <CommonComment DOC_ID={'FREE'}/>
                            </ul>
                        </div>

                        {/*<div className='home-disqus'>
                            <div className="card card--material">
                                <DisqusBoard url={'/home'} identifier={'HOME'} title={'자유 게시판'}/>
                            </div>
                        </div>*/}

                        {/*<Link to="/">Intro</Link>
                        <Link to="/home">Home</Link>
                        <Link to="/about-us">About</Link>
                        <Link to="/roomList">RoomList</Link>
                        <Link to="/room">Room</Link>
                        <Link to="/subjectList">과목</Link>
                        <Link to="/category">카테고리</Link>
                        <Link to="/signIn">로그인</Link>
                        <Link to="/signUp">가입</Link>
                        <Link to="/manageFriends">친구관리</Link>
                        <Link to="/messageOnlineList">메시지</Link>

                        <button onClick={this.logOut}>로그 아웃</button>
                        <button onClick={this.requestCurrentLocation}>현 위치 확인</button>
                        <button onClick={() => alert(window.isRNWebView)}>IS RN</button>*/}

                        <ActionSheet className="target-schedule-action-sheet" isOpen={TSAS.open} animation='default' modifier={'material'}
                                     onCancel={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: false}})} isCancelable={true} title={TSAS.title}>
                            <div className="segment segment--material">
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input" name="target-schedule-segment" checked={TSAS.tab === 'schedule'} onChange={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, tab: 'schedule'}})}/>
                                        <div className="segment__button segment--material__button TUTO_SCHEDULE_TAB_BUTTON">{'지도 + 장소'}</div>
                                </div>
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input TUTO_SCHEDULE_DESCRIPTION_TAB_INPUT" name="target-schedule-segment" checked={TSAS.tab === 'description'} onChange={() =>  this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, tab: 'description'}})}/>
                                        <div className="segment__button segment--material__button TUTO_SCHEDULE_DESCRIPTION_TAB_BUTTON">{'설명 + 댓글'}</div>
                                </div>
                            </div>
                            <div className="card card--material" style={{display: TSAS.tab === 'schedule' ? '' : 'none'}}>
                                <NaverMap
                                    id={'naver-map-for-target'}
                                    className={'naver--map create-plan-naver-map-for-target TUTO_NAVER_MAP'}
                                    naverRef={ref => { this.naverMapRef = ref }}
                                    style={{width: window.innerWidth, height: GET_HEIGHT_FOR_NAVER_MAP(window.screenSizeProperty === 'md' ? 450 : 250)}}
                                    defaultZoom={8}
                                    minZoom={3}
                                    maxZoom={14}
                                    zoomControl={true}
                                    zoomControlOptions={
                                        {position: this.naverMaps.Position.TOP_RIGHT, style: this.naverMaps.ZoomControlStyle.SMALL, legendDisabled: false}
                                    }
                                    center={TSAS.mapCenter}
                                    onCenterChanged={center => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, mapCenter: center}})}
                                    logoControl={false}
                                    mapDataControl={false}
                                >
                                    <button className="button button--material--flat map-current-button" onClick={this.requestCurrentLocation}>
                                        <i className="ion ion-android-locate"/>
                                    </button>

                                    {
                                        TSAS.open ?
                                            TSAS.data.scheduleOrder.map((key, i) => {
                                                return (
                                                    <Marker key={['scheduled', 'marker', key, i].join('_')}
                                                            position={new this.naverMaps.LatLng(TSAS.data.schedule[key].y, TSAS.data.schedule[key].x)}
                                                            icon= {
                                                                {content: ['<div class="naver-map-pin-mine"',
                                                                        'id="',
                                                                        ['scheduled', 'marker', key, i].join('_'),
                                                                        '">',
                                                                        '<strong>',
                                                                        i + 1,
                                                                        '</strong>',
                                                                        SVG_MARKER_ICON[TSAS.data.schedule[key].type],
                                                                        '</div>'].join('')}
                                                            }
                                                            onClick={(event) => {
                                                                this.showNaverPlaceInFunctions(TSAS.data.schedule[key])
                                                            }}
                                                    />
                                                )
                                            })
                                            :
                                            null
                                    }

                                    {
                                        TSAS.targetToMapCenter ?
                                            <Marker position={new this.naverMaps.LatLng(TSAS.targetToMapCenter.y, TSAS.targetToMapCenter.x)}
                                                    icon= {{content: ['<div class="naver-map-target-to-map-center"', '</div>'].join('')}}
                                            />
                                            :
                                            null
                                    }

                                    {
                                        TSAS.open ?
                                            <Polyline
                                                path={TSAS.polyLine}
                                                strokeColor={'#ffe336'}
                                                strokeStyle={'solid'}
                                                strokeOpacity={0.8}
                                                strokeWeight={3}
                                            />
                                            :
                                            null
                                    }
                                </NaverMap>

                                <ul className="list list--material target-schedule-list TUTO_SCHEDULE_LIST">
                                {
                                    TSAS.open ?
                                        TSAS.data.scheduleOrder.map((key, i) => {
                                            const e = TSAS.data.schedule[key];
                                            return (
                                                <li key={['list', key, i].join('_')} className="list-item list-item--material">
                                                    <div className="list-item__left list-item--material__left" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                        <img className="list-item__thumbnail"
                                                             src={NAVER_THUMBNAIL_GETTER(e)} onError={(event)=>{event.target.src = "https://fakeimg.pl/100x100/?text=No Image"}} alt={e.name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                        <div className="list-item__title list-item--material__title">{i + 1}. {e.name} {e.category ? <small>{e.category}</small>: null}</div>
                                                        <div className="list-item__subtitle list-item--material__subtitle">{e.tags ? e.tags.join(", ") : null}</div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right" onClick={(event) => this.setTargetToMapCenter(event, e)}>
                                                        <span><i className="fa fa-map-marker-alt"/></span>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        :
                                        null
                                }
                                </ul>

                                {
                                    TSAS.open ?
                                        <TargetScheduleActionSheetFunctions TSAS={TSAS} hideTNPAS={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetNaverPlaceActionSheet: null}})}/>
                                        :
                                        null
                                }
                            </div>

                            {
                                TSAS.open && TSAS.tab === 'description' ?
                                    <div className="card card--material target-schedule-description-wrapper">
                                        <TargetScheduleActionSheetDescription TSAS={TSAS}/>
                                    </div>
                                    :
                                    <div/>
                            }
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>일정 닫기</ActionSheetButton>
                        </ActionSheet>


                        {
                        this.state.userInfoDialog.open ?
                            <UserInfoDialog open={true} uid={this.state.userInfoDialog.uid} hide={() => this.setState({userInfoDialog: {...this.state.userInfoDialog, open: false}})}/>
                            :
                            null
                    }

                        {
                            this.state.noticeActionSheet.open ?
                                <NoticeActionSheet open={this.state.noticeActionSheet.open} hide={() => this.setState({noticeActionSheet: {...this.state.noticeActionSheet, open: false}})}/>
                                :
                                null
                        }

                        {
                            this.state.nearPlaceListActionSheet.open ?
                                <NearPlaceListActionSheet open={this.state.nearPlaceListActionSheet.open} placeId={this.state.nearPlaceListActionSheet.placeId} placeName={this.state.nearPlaceListActionSheet.placeName} showTargetSchedule={(target) => this.showTargetSchedule(target)} hide={() => this.setState({nearPlaceListActionSheet: {...this.state.nearPlaceListActionSheet, open: false}})}/>
                                :
                                null
                        }
                    </Page>
                </SplitterContent>
            </Splitter>
        )
    }
}

const mapStateToProps = ({user, native}) => ({
    userInfo: user.userInfo,
    usedCurrentLocation: native.usedCurrentLocation,
    currentLocation: native.currentLocation,
});

const mapDispatchToProps = dispatch => ({
    removeUserInfo: () => dispatch(removeUserInfo()),
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    useCurrentLocation: () => dispatch(useCurrentLocation()),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Home))